import axios from "axios";
import config from "../config";

// Navigation callback system

let navigationCallback = null;
let isNavigating = false; // Flag to prevent infinite loops


export const setNavigationCallback = (callback) => {
  navigationCallback = callback;
};

export const resetNavigationFlag = () => {
  isNavigating = false;
};

const instance = axios.create({
  baseURL: config.archeoBaseUrl,
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("authToken");
    const selectedOrganization = JSON.parse(localStorage.getItem("organization"));


    if (accessToken && selectedOrganization) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["X-Archeoorganization"] = selectedOrganization.id;
      // selectedOrganization will be passed as a parameter to individual methods
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 && !isNavigating) {
      isNavigating = true; // Set flag to prevent multiple navigations
      localStorage.removeItem("authToken");
      localStorage.removeItem("organization");
      
      // Use callback if available, otherwise fallback to window.location
      if (navigationCallback) {
        navigationCallback("/signin");
      } else {
        window.location.href = "/signin";
      }
      
      return Promise.reject(error.response);
    } else {
      return Promise.reject(error.response);
    }
  }
);

// Base methods without organization header
const get = (url, params, config = {}) => {
  const headers = { ...config.headers };
  return instance.get(url, { params, ...config, headers });
};

const post = (url, data, config = {}) => {
  const headers = { ...config.headers };
  return instance.post(url, data, { ...config, headers });
};

const put = (url, data, config = {}) => {
  const headers = { ...config.headers };
  return instance.put(url, data, { ...config, headers });
};

const del = (url, config = {}) => {
  const headers = { ...config.headers };
  return instance.delete(url, { ...config, headers });
};

// Export base methods
const methods = { get, post, put, delete: del };

export default methods;
